// extracted by mini-css-extract-plugin
export default {"dash_btns":"DashboardLayout_dash_btns__edwhO"};